export const PawMark = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true" data-testid="paw-mark">
    <g fill="currentColor">
      <ellipse cx="32" cy="44" rx="13" ry="10" />
      <ellipse cx="14.5" cy="29" rx="5.4" ry="7.2" transform="rotate(-18 14.5 29)" />
      <ellipse cx="26" cy="19.5" rx="5.6" ry="7.4" transform="rotate(-6 26 19.5)" />
      <ellipse cx="38" cy="19.5" rx="5.6" ry="7.4" transform="rotate(6 38 19.5)" />
      <ellipse cx="49.5" cy="29" rx="5.4" ry="7.2" transform="rotate(18 49.5 29)" />
    </g>
  </svg>
);

export const PawStamp = ({ className = "w-14 h-14" }) => (
  <div
    className={`rounded-full border-2 border-current flex items-center justify-center rotate-[-12deg] ${className}`}
    aria-hidden="true"
  >
    <PawMark className="w-3/5 h-3/5" />
  </div>
);
